export default "__VITE_ASSET__BB9W96fo__"